import { render } from "./likedSongsComponent.vue?vue&type=template&id=201e2ea9&scoped=true"
import script from "./likedSongsComponent.vue?vue&type=script&lang=js"
export * from "./likedSongsComponent.vue?vue&type=script&lang=js"

import "./likedSongsComponent.vue?vue&type=style&index=0&id=201e2ea9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201e2ea9"]])

export default __exports__